import script from "./OpeningHours.vue?vue&type=script&setup=true&lang=js"
export * from "./OpeningHours.vue?vue&type=script&setup=true&lang=js"

import "./OpeningHours.vue?vue&type=style&index=0&id=4e17213f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e17213f"]])

export default __exports__